import {
  Box,
  SectionLabel,
  Text,
} from "@salestrak/ui";
import type { ObjectAccessLevel } from "#app/lib/data";
import { RoleSelector } from "#app/components/entity-selectors/role-selector";
import { TeamSelector } from "#app/components/entity-selectors/team-selector";
import { userRefToEntity } from "#app/lib/entity-visuals";
import { useInvitableRoles } from "#app/lib/hooks/use-invitable-roles";
import { AccessLevelMenu } from "./access-level-menu";
import { ACCESS_ROW_HEIGHT, AccessRowFrame } from "./access-row";

export function InviteForm({
  email,
  roleId,
  onRoleChange,
  allowedRoleIds,
  access,
  onAccessChange,
  teamIds,
  onTeamIdsChange,
}: {
  email: string;
  roleId: string | null;
  onRoleChange: (roleId: string | null) => void;
  allowedRoleIds: ReturnType<typeof useInvitableRoles>["allowedRoleIds"];
  access: ObjectAccessLevel;
  onAccessChange: (level: ObjectAccessLevel) => void;
  teamIds: string[];
  onTeamIdsChange: (ids: string[]) => void;
}) {
  return (
    <Box gap="2xs">
      <Box height={32} justify="center">
        <SectionLabel>Invite to the workspace</SectionLabel>
      </Box>
      <AccessRowFrame
        entity={userRefToEntity({ userId: email, email, memberStatus: "invited" })}
        label={email}
        meta="New member"
      >
        <RoleSelector
          value={roleId}
          onValueChange={onRoleChange}
          allowedRoleIds={allowedRoleIds}
        />
        <AccessLevelMenu value={access} onChange={onAccessChange} />
      </AccessRowFrame>
      <Box direction="row" align="center" gap="base" minHeight={ACCESS_ROW_HEIGHT}>
        <Box width={24} />
        <Text size="sm" variant="muted">
          Add to team
        </Text>
        <Box flex={1} minWidth={0}>
          <TeamSelector
            value={teamIds}
            onValueChange={onTeamIdsChange}
            placeholder="Search teams..."
            icon="users"
            summary
            fill
          />
        </Box>
      </Box>
    </Box>
  );
}
